import styles from './MainContentPending.module.css';
import { MainSectionWrapper } from '../mainSectionWrapper/';
import { TitleSectionWrapper } from '../titleSectionWrapper/TitleSectionWrapper';

const MainContentPending = (props) => {
    return (
        <div
            className={styles.MainContentPending}
            data-testid={props['data-testid'] || 'main-content-pending'}
        >
            <TitleSectionWrapper>
                <div className={styles.pendingItem} />
            </TitleSectionWrapper>
            <MainSectionWrapper>
                <div className={styles.MainSectionPending}>
                    <div className={styles.longPendingItem} />
                    <div className={styles.smallPendingItem} />
                </div>
            </MainSectionWrapper>
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default MainContentPending;
